import React from 'react'
// constants
import { ENTITIES } from 'constants/index'
// static
import { ObjectivesIcon, PlansIcon } from 'components/Modals/PlanItems/components/PlanLinks/components/LinkedItem/view'
import { ActionsIcon, MeasuresIcon as KpisIcon } from 'themes/views/objectivesList'

export const getIconByEntity = (entityType: string) => {
  switch (entityType) {
    case ENTITIES.PLAN:
      return <PlansIcon />
    case ENTITIES.PLAN_OBJECTIVE:
      return <ObjectivesIcon />
    case ENTITIES.PLAN_ACTION:
      return <ActionsIcon />
    case ENTITIES.PLAN_KPI:
      return <KpisIcon />
    default:
      return null
  }
}
